// Shared constants for the Consumer Health Data (CHD) consent gate.
// A user is considered to have active consent when their most recent
// consent_events row for CHD_CONSENT_TYPE has action 'granted'.

export const CHD_CONSENT_TYPE = "consumer_health_data" as const;
export const CHD_POLICY_VERSION = "chd-v1-2026-06" as const;
